<ng-container [formGroup]="formGroup">
    <div class="form-row">
        <div class="form-group col-md-4">
            <label for="enteProprietarioGestore">Ente competente / Ente gestore <span *ngIf="formGroup.get('tipoInserimento')?.value !== null && formGroup.get('tipoInserimento')?.value !== undefined && formGroup.get('tipoInserimento')?.value !== 2">*</span></label>
            <input class="form-control" id="enteProprietarioGestore" formControlName="enteProprietarioGestore" type="text">
        </div>
        <div class="form-group col-md-4">
            <label for="enteManutentore">Ente manutentore</label>
            <input class="form-control" id="enteManutentore" formControlName="enteManutentore" type="text">
        </div>
        <div class="form-group col-md-4">
            <label for="annoFineEsistenza">Anno fine esistenza</label>
            <input class="form-control" id="annoFineEsistenza" formControlName="annoFineEsistenza" type="number">
        </div>
    </div>
    <div class="form-row">
        <div class="form-group col-md-4">
            <label for="idMaterialeCostruzione">Materiale costruzione</label>
            <select class="form-control" formControlName="idMaterialeCostruzione" id="idMaterialeCostruzione">
                <option [ngValue]="null">Seleziona un'opzione...</option>
                <option *ngFor="let item of datalist.materiale" [ngValue]="item.id">{{ item.descrizione }}</option>
            </select>
        </div>
        <div class="form-group col-md-4">
            <label for="idMaterialeRivestimento">Materiale rivestimento</label>
            <select class="form-control" formControlName="idMaterialeRivestimento" id="idMaterialeRivestimento">
                <option [ngValue]="null">Seleziona un'opzione...</option>
                <option *ngFor="let item of datalist.materiale" [ngValue]="item.id">{{ item.descrizione }}</option>
            </select>
        </div>
        <!-- <div class="form-group col-md-4">
            <label for="idSponda">Sponda</label>
            <select class="form-control" formControlName="idSponda" id="idSponda">
                <option *ngFor="let item of datalist.sponda" [ngValue]="item.id">{{ item.descrizione }}</option>
            </select>
        </div> -->
    </div>
    <div class="form-row">
        <div class="form-group col-md-4">
            <label for="quotaMedMetri">Quota media (metri)</label>
            <input onlyNumbers class="form-control" id="quotaMedMetri" formControlName="quotaMedMetri" type="number">
        </div>
        <div class="form-group col-md-4">
            <label for="quotaMinMetri">Quota minima (metri)</label>
            <input onlyNumbers class="form-control" id="quotaMinMetri" formControlName="quotaMinMetri" type="number">
        </div>
        <div class="form-group col-md-4">
            <label for="quotaMaxMetri">Quota massima (metri)</label>
            <input onlyNumbers class="form-control" id="quotaMaxMetri" formControlName="quotaMaxMetri" type="number">
        </div>
        <div class="form-group col-md-4">
            <label for="altezzaMetri">Altezza (metri)</label>
            <input currencyMask [options]="{inputMode: natural,allowNegative: false, align: 'left', prefix: '', thousands: '.', decimal: ',' }" class="form-control" id="altezzaMetri" formControlName="altezzaMetri" type="text">
        </div>
        <div class="form-group col-md-4">
            <label for="lunghezzaMetri">Lunghezza (metri)</label>
            <input currencyMask [options]="{inputMode: natural,allowNegative: false, align: 'left', prefix: '', thousands: '.', decimal: ',' }" class="form-control" id="lunghezzaMetri" formControlName="lunghezzaMetri" type="text">
        </div>
        <div class="form-group col-md-4">
            <label for="larghezzaMetri">Larghezza (metri)</label>
            <input currencyMask [options]="{inputMode: natural,allowNegative: false, align: 'left', prefix: '', thousands: '.', decimal: ',' }" class="form-control" id="larghezzaMetri" formControlName="larghezzaMetri" type="text">
        </div>
        <div class="form-group col-md-4">
            <label for="volumeMC">Volume (metri cubi)</label>
            <input currencyMask [options]="{inputMode: natural,allowNegative: false, align: 'left', prefix: '', thousands: '.', decimal: ',' }" class="form-control" id="volumeMC" formControlName="volumeMC" type="text">
        </div>
        <div class="form-group col-md-4">
            <label for="areaMQ">Area (metri quadri)</label>
            <input currencyMask [options]="{inputMode: natural,allowNegative: false, align: 'left', prefix: '', thousands: '.', decimal: ',' }" class="form-control" id="areaMQ" formControlName="areaMQ" type="text">
        </div>
    </div>
</ng-container>